import * as React from 'react';
import { withIntent } from '../../../util/hoc/withIntent.js';
import { BaseSolidTrack as SolidTrackMemoized } from './components/SolidTrack.js';

var Track = function Track(props) {
  return /*#__PURE__*/React.createElement(SolidTrackMemoized, props);
};
var ThemableTrack = withIntent(Track);
var TrackMemoized = /*#__PURE__*/React.memo(ThemableTrack);

export { ThemableTrack as BaseTrack, TrackMemoized as Track };
//# sourceMappingURL=Track.js.map
